import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DIVIDEND DISTRIBUTION RELATED APIs
// ==============================================

// 1. Get Dividend Distribution Creation Data (POST)
export const getDividendDistributionCreationData = async (params) => {
    try {
        const { financialYear } = params;

        // Validate required parameters
        if (!financialYear) {
            throw new Error('Financial Year is required');
        }


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDividendDistributionCreationData`,
            {
                params: {
                    financialYear: financialYear  // ✅ Sent as query parameter
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Insert Dividend Distribution (POST)
export const insertDividendDistribution = async (params) => {
    try {

        // Validate required parameters
        if (!params.dividendDeclarationId) {
            throw new Error('Dividend Declaration ID is required');
        }
        if (!params.lotName) {
            throw new Error('Lot Name is required');
        }
        if (!params.tdsPercentage === undefined) {
            throw new Error('TDS Percentage is required');
        }
        if (!params.createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.roleId) {
            throw new Error('RoleId is required');
        }

        // ✅ Use PascalCase to match C# model properties
        const payload = {
            DividendDeclarationId: parseInt(params.dividendDeclarationId),           // Capital D, D, I
            LotName: params.lotName.toString().trim(),                               // Capital L, N
            LotDescription: params.lotDescription?.toString().trim() || '',          // Capital L, D
            TDSPercentage: parseFloat(params.tdsPercentage),                        // Capital TDS, P
            ShareholderIdsPromoter: params.shareholderIdsPromoter?.toString().trim() || '',  // Capital S, I, P
            ShareholderIdsESOP: params.shareholderIdsESOP?.toString().trim() || '',
            TDSApplicablePromoters: params.tdsApplicablePromoters?.toString().trim() || '',
            TDSApplicableESOP: params.tdsApplicableESOP?.toString().trim() || '',         // Capital S, I, ESOP
            Remarks: params.remarks?.toString().trim() || '',                        // Capital R
            Createdby: params.createdby.toString().trim(),                          // Capital C
            RoleId: parseInt(params.roleId)                                         // Capital R, I
        };


        const response = await axios.post(
            `${API_BASE_URL}/Accounts/InsertDividendDistribution`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve/Verify/Reject Dividend Distribution (PUT)
export const approveDividendDistribution = async (params) => {
    try {

        // Validate required parameters
        if (!params.transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }
        if (!params.roleid) {
            throw new Error('RoleId is required');
        }
        if (!params.action) {
            throw new Error('Action is required');
        }
        if (!params.createdby) {
            throw new Error('Createdby is required');
        }

        // ✅ Use PascalCase to match C# model
        const payload = {
            TransactionRefno: parseInt(params.transactionRefno),  // Capital T, R
            Roleid: parseInt(params.roleid),                      // Capital R
            Action: params.action.toString().trim(),              // Capital A
            Note: params.note?.toString().trim() || '',           // Capital N
            Createdby: params.createdby.toString().trim()         // Capital C
        };


        const response = await axios.put(
            `${API_BASE_URL}/Accounts/ApproveDividendDistribution`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Verify Dividend Distribution Inbox (GET)
export const getVerifyDividendDistribution = async (params) => {
    try {
        const { roleId } = params;

        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerifyDividendDistribution/${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Dividend Distribution by Reference Number (GET)
export const getDividendDistributionByRefno = async (params) => {
    try {
        const { transactionRefno } = params;

        // Validate required parameters
        if (!transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDividendDistributionByRefno/${transactionRefno}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};